var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26,
    r: 26,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 13.167V37.0554H28.4062C27.8569 36.4365 27.5769 35.6656 27.5769 34.8838H14.6538V15.3387H21.1154V20.7679H29.7308V15.3387H36.1923V26.197H38.3462V13.167H12.5ZM23.2692 18.5962H27.5769V15.3387H23.2692V18.5962ZM25.4231 27.2829V29.4546H16.8077V27.2829H25.4231ZM16.8077 32.7121H23.2692V30.5404H16.8077V32.7121ZM33.4128 33.798H38.3462V28.3688H40.5V35.9697H33.402L35.8768 38.465L34.354 40.0003L30.0463 35.657C29.6252 35.2324 29.6252 34.5451 30.0463 34.1216L34.354 29.7782L35.8768 31.3136L33.4128 33.798Z",
    fill: "#212129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirect-icon.e2a6d27180892dc7c329c5e85a15a8ce.svg";
export { ForwardRef as ReactComponent };